const { same } = require('../utils');

exports.computeHasTotalColumnFromTables = tables => same(tables, 'hasTotalColumn', false);
